"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateFilterOutputByType = exports.formatDateFilterInputByType = exports.DateType = exports.DateRangeField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _alloyReactDatePicker = _interopRequireDefault(require("@adsk/alloy-react-date-picker"));
var _DateFieldFooter = require("./DateFieldFooter");
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _dateUtils = require("../../utils/data/dateUtils");
var _useTranslations = require("../../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let DateType = exports.DateType = /*#__PURE__*/function (DateType) {
  DateType["Past"] = "past";
  DateType["Due"] = "due";
  DateType["Start"] = "start";
  return DateType;
}({});
/**
 * @TODO: I think we're complecting two things:
 * A) the format of the date
 * (i.e. whether it is a day string, or a full UTC date)
 *
 * is being complected with
 *
 * B) whether we want a range of what's due or in the past.
 *
 * For now, because we only have these two specific types of filters,
 * I think it's okay that those are complected, but it's plausible
 * that we would want to have something that uses day strings and be in the past.
 */
const formatDateFilterOutputByType = (date, type) => {
  if (!date) {
    return null;
  }
  switch (type) {
    case DateType.Due:
    case DateType.Start:
      // we need to return it as `YYY-MM-DD` only
      return (0, _dateUtils.getDateFormatToDays)(date);
    case DateType.Past:
      return date.toISOString();
    default:
      return null;
  }
};
exports.formatDateFilterOutputByType = formatDateFilterOutputByType;
const formatDateFilterInputByType = (dateString, type) => {
  if (!dateString) {
    return undefined;
  }
  switch (type) {
    case DateType.Due:
    case DateType.Start:
      // getDateStringAsDate adds time zone adjustment from `YYYY-MM-DD`,
      return (0, _dateUtils.getDateStringAsDate)(dateString);
    case DateType.Past:
      return new Date(dateString);
    default:
      return undefined;
  }
};
exports.formatDateFilterInputByType = formatDateFilterInputByType;
const useDateRangeActions = type => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return (0, _react.useMemo)(() => {
    switch (type) {
      case DateType.Due:
        return [{
          id: "OVERDUE",
          label: T.translate("filterPanel.dateRange.presets.overdue"),
          getActionRange: _dateUtils.getOverdueRange
        }, {
          id: "TODAY",
          label: T.translate("filterPanel.dateRange.presets.today"),
          getActionRange: _dateUtils.getTodayRange
        }, {
          id: "7_DAYS",
          label: T.translate("filterPanel.dateRange.presets.nextXDays", {
            days: 7
          }),
          getActionRange: () => (0, _dateUtils.getNextXDaysRange)(7)
        }, {
          id: "14_DAYS",
          label: T.translate("filterPanel.dateRange.presets.nextXDays", {
            days: 14
          }),
          getActionRange: () => (0, _dateUtils.getNextXDaysRange)(14)
        }, {
          id: "30_DAYS",
          label: T.translate("filterPanel.dateRange.presets.nextXDays", {
            days: 30
          }),
          getActionRange: () => (0, _dateUtils.getNextXDaysRange)(30)
        }];
      case DateType.Start:
        return [{
          id: "PAST_30_DAYS",
          label: T.translate("filterPanel.dateRange.presets.pastXDays", {
            days: 30
          }),
          getActionRange: () => (0, _dateUtils.getPastXDaysRange)(30)
        }, {
          id: "PAST_7_DAYS",
          label: T.translate("filterPanel.dateRange.presets.pastXDays", {
            days: 7
          }),
          getActionRange: () => (0, _dateUtils.getPastXDaysRange)(7)
        }, {
          id: "TODAY",
          label: T.translate("filterPanel.dateRange.presets.today"),
          getActionRange: _dateUtils.getTodayRange
        }, {
          id: "NEXT_7_DAYS",
          label: T.translate("filterPanel.dateRange.presets.nextXDays", {
            days: 7
          }),
          getActionRange: () => (0, _dateUtils.getNextXDaysRange)(7)
        }, {
          id: "NEXT_30_DAYS",
          label: T.translate("filterPanel.dateRange.presets.nextXDays", {
            days: 30
          }),
          getActionRange: () => (0, _dateUtils.getNextXDaysRange)(30)
        }];
      case DateType.Past:
        return [{
          id: "TODAY",
          label: T.translate("filterPanel.dateRange.presets.today"),
          getActionRange: _dateUtils.getTodayRange
        }, {
          id: "YESTERDAY",
          label: T.translate("filterPanel.dateRange.presets.yesterday"),
          getActionRange: _dateUtils.getYesterdayRange
        }, {
          id: "7_DAYS",
          label: T.translate("filterPanel.dateRange.presets.pastXDays", {
            days: 7
          }),
          getActionRange: () => (0, _dateUtils.getPastXDaysRange)(7)
        }, {
          id: "14_DAYS",
          label: T.translate("filterPanel.dateRange.presets.pastXDays", {
            days: 14
          }),
          getActionRange: () => (0, _dateUtils.getPastXDaysRange)(14)
        }, {
          id: "30_DAYS",
          label: T.translate("filterPanel.dateRange.presets.pastXDays", {
            days: 30
          }),
          getActionRange: () => (0, _dateUtils.getPastXDaysRange)(30)
        }];
      default:
        return [];
    }
  }, [type, T]);
};
const FooterButtons = _ref => {
  let {
    type,
    selectedRange,
    onChange,
    toggleOverlay
  } = _ref;
  const dateRangeActions = useDateRangeActions(type);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dateRangeActions.map(_ref2 => {
    let {
      id,
      label,
      getActionRange
    } = _ref2;
    const {
      startDate,
      endDate
    } = getActionRange();
    const isDateRangeSelected = !!selectedRange && (0, _dateUtils.isSameDateRange)(selectedRange, {
      startDate: startDate && (type === DateType.Past ? startDate.toISOString() : (0, _dateUtils.getDateFormatToDays)(startDate)),
      endDate: endDate && (type === DateType.Past ? endDate.toISOString() : (0, _dateUtils.getDateFormatToDays)(endDate))
    });
    return /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
      style: {
        marginRight: "8px",
        marginBottom: "8px"
      },
      key: id,
      size: _alloyReactButton.default.SIZES.SMALL,
      onClick: () => {
        if (!isDateRangeSelected) {
          const {
            startDate,
            endDate
          } = getActionRange();
          onChange([startDate, endDate]);
          toggleOverlay();
        } else {
          onChange(undefined);
        }
      },
      selected: isDateRangeSelected,
      variant: isDateRangeSelected ? _alloyReactButton.default.VARIANTS.PRIMARY : undefined
    }, label);
  }));
};
const DateRangeField = _ref3 => {
  let {
    type,
    range,
    onChange,
    container,
    ...props
  } = _ref3;
  const onDateSelectionChanged = (0, _react.useCallback)(changeResult => {
    if (!changeResult) {
      onChange({
        startDate: null,
        endDate: null
      });
      return;
    }
    const [startDate, endDate] = changeResult;
    onChange({
      startDate: formatDateFilterOutputByType(startDate, type),
      endDate: formatDateFilterOutputByType(endDate, type)
    });
  }, [onChange, type]);
  const startDate = range && formatDateFilterInputByType(range.startDate, type);
  const endDate = range && formatDateFilterInputByType(range.endDate, type);
  return /*#__PURE__*/_react.default.createElement(_alloyReactDatePicker.default, _extends({
    format: _alloyReactDatePicker.default.VALID_FORMATS.DEFAULT,
    range: true,
    allowSameStartAndEndDate: true,
    startDate: startDate || null,
    endDate: endDate || null,
    onChange: onDateSelectionChanged,
    disableFutureDates: type === DateType.Past,
    container: container,
    triggerProps: {
      style: {
        width: "100%"
      }
    },
    renderFooter: _ref4 => {
      let {
        reset,
        toggleOverlay
      } = _ref4;
      return /*#__PURE__*/_react.default.createElement(_DateFieldFooter.DateFieldFooter, {
        reset: reset,
        toggleOverlay: toggleOverlay,
        disabled: !startDate && !endDate
      }, /*#__PURE__*/_react.default.createElement(FooterButtons, {
        type: type,
        selectedRange: range,
        onChange: onDateSelectionChanged,
        toggleOverlay: toggleOverlay
      }));
    }
  }, props));
};
exports.DateRangeField = DateRangeField;
//# sourceMappingURL=DateRangeField.js.map